import { Component, OnInit, Input, EventEmitter, OnChanges, SimpleChanges, Output, HostListener } from '@angular/core';
import { HistoryItem } from 'src/app/models/history';
import { getStatus } from '../../../util/tools'


@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

  @Input() show: boolean;
  @Input() modalHistoryItem: HistoryItem;
  @Output() closed = new EventEmitter<boolean>();
  public getStatus: Function = getStatus;

  public onBackgroundClickClose(event): void {
    const { id, className } = event.target;
    if (id == 'myModal' && className == 'modal') {
      this.show = false;
      this.isClosedToParent(this.show);
    }
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.show = false;
    this.isClosedToParent(this.show);
  }

  public onClose(): void {
    this.show = false;
    this.isClosedToParent(this.show);
  }

  public isClosedToParent(value: boolean): void {
    this.closed.emit(value);
  }
}
